"use strict";

exports.__esModule = true;
exports["default"] = Baidu;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Baidu(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M78 19l-.2.2L50 40l28 21c.1.1.2.2.3.4.2-.7.3-1.3.3-2V20.7c0-.7-.1-1.3-.3-2l-.3.3zM39.9 44.7c-2.6 0-4.9-.8-6.9-2.2l-28 21c1.1 1 2.4 1.7 4 1.7h61.9c1.6 0 3-.6 4-1.7L46.8 42.4c-2 1.5-4.3 2.3-6.9 2.3zM2 19c-.1-.1-.2-.2-.3-.4-.2.7-.3 1.3-.3 2v38.7c0 .7.1 1.3.3 2 .1-.1.2-.2.3-.4l.2-.2L30 39.9 2 19zM39.9 40.8c2.1 0 4-.8 5.4-2.2l.2-.2 29.3-21.9c-1.1-1-2.4-1.7-4-1.7H9c-1.6 0-3 .6-4 1.7l29.5 22.1c1.4 1.4 3.3 2.2 5.4 2.2z"
  })));
}